const SANDBOX_LABEL = 'sandbox';

/**
 * Sandbox hosts nest one extra label ahead of the tenant:
 *   prod    → concera.nacsoftcontracts.com
 *   sandbox → sandbox.concera.nacsoftcontracts.com
 *
 * Strips that label so the tenant is read from the next one. Only strips when a
 * tenant label actually follows — `sandbox.nacsoftcontracts.com` is the sandbox
 * app root, not a tenant, and stays reserved like `www`.
 */
export function stripSandboxLabel(hostname) {
  const host = String(hostname || '').toLowerCase();
  const parts = host.split('.');
  if (parts.length > 3 && parts[0] === SANDBOX_LABEL) return parts.slice(1).join('.');
  return host;
}

export function isTenantSubdomain() {
  if (typeof window === 'undefined') return false;
  const host = stripSandboxLabel(window.location.hostname);
  if (host === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return false;
  const parts = host.split('.');
  if (parts.length <= 2) return false;
  const first = parts[0];
  if (first === 'www' || first === 'api' || first === 'office' || first === 'backstage') return false;
  if (first === SANDBOX_LABEL) return false;
  return true;
}
